import { Translations } from './types';

export const ptBR: Translations = {
  // App & Branding
  app_title: 'Slimelings: Bit-It!',
  app_subtitle: 'O Jogo de Cartas de Blefe e Estratégia',
  app_slogan: 'O dobro da encrenca... metade do remorso.',
  app_description: 'Partidas dinâmicas de 1 a 4 jogadores. Blefe, encare o Bit-It! e alcance a meta de 16 pontos.',

  // Locales
  lang_pt: 'Português (BR)',
  lang_en: 'English (US)',
  lang_pl: 'Polski (PL)',

  // Game Modes
  mode_duel: 'Duelo 1x1',
  mode_duel_desc: 'Disputa frente a frente contra 1 oponente.',
  mode_teams: 'Duplas 2x2',
  mode_teams_desc: 'Você e seu parceiro contra a dupla adversária.',
  mode_ffa: 'Todos Contra Todos (4P FFA)',
  mode_ffa_desc: 'Caos tático: 4 jogadores disputando cada turno individualmente.',

  // Bot Personalities & Levels
  bot_level_1: 'Nível 1 (Fácil)',
  bot_level_2: 'Nível 2 (Médio)',
  bot_level_3: 'Nível 3 (Difícil)',
  bot_aggressive: 'Nível 3 (Difícil)',
  bot_cautious: 'Nível 1 (Fácil)',
  bot_minimax: 'Nível 2 (Médio)',
  bot_aggressive_desc: 'Nível 3',
  bot_cautious_desc: 'Nível 1',
  bot_minimax_desc: 'Nível 2',

  // Navigation & Lobby
  tab_solo: 'Modo Solo (vs Bots)',
  tab_multiplayer: 'Multiplayer Online',
  tab_rules: 'Regras Oficiais',
  btn_create_room: 'Criar Mesa',
  btn_join_room: 'Entrar na Sala',
  btn_start_game: 'Começar Partida',
  btn_add_bot: 'Adicionar Bot',
  btn_leave: 'Sair da Sala',
  btn_copy_link: 'Copiar Link',
  link_copied: 'Link copiado para a área de transferência!',
  room_code: 'Código da Sala',
  enter_room_code: 'Digite o código da sala (ex: SLIME-8)',
  room_status_waiting: 'Aguardando jogadores...',
  room_status_playing: 'Partida em andamento',
  room_private: 'Sala Privada',
  room_public: 'Sala Pública',
  toggle_public: 'Tornar Sala Pública',
  toggle_private: 'Tornar Sala Privada',
  public_rooms: 'Salas Públicas Abertas',
  no_public_rooms: 'Nenhuma sala pública aberta no momento. Crie a sua!',
  players_joined: 'Jogadores na mesa',
  player_you: 'Você',
  player_host: 'Criador da Sala',
  player_bot: 'Bot IA',
  team_a: 'Equipe Azul (A)',
  team_b: 'Equipe Vermelha (B)',

  // In-Game Actions
  action_bit_it: 'BIT-IT! (Dobrar)',
  action_double_bit_it: 'DOUBLE BIT-IT! (Redobrar)',
  action_face: 'Encarar Desafio',
  action_fold: 'Fugir (Proteger)',
  action_play_card: 'Jogar Carta',
  action_drag_or_tap: 'Arraste a carta para o centro ou toque para jogar',
  your_turn: 'Sua vez de jogar!',
  waiting_for_player: 'Aguardando jogada de {name}...',
  waiting_for_challenge_response: 'Aguardando resposta ao desafio...',
  btn_dismiss_hint: 'Fechar dica',

  // Announcements & Game Events
  event_bit_it_called: '{name} pediu BIT-IT! Aposta elevada para {stakes} pontos.',
  event_double_bit_it_called: '{name} respondeu com DOUBLE BIT-IT! Aposta máxima de {stakes} pontos.',
  event_player_faced: '{name} encarou o desafio.',
  event_player_folded: '{name} fugiu e protegeu seu placar.',
  event_bluff_win: 'Todos fugiram. {name} venceu a rodada por blefe!',
  event_corven_slay: 'Abate do Ezarion! {name} usou Corven e abateu Ezarion. Vitória imediata da rodada!',
  event_trick_won: 'Turno {trick}: {name} venceu com {card} (Poder {power}).',
  event_trick_tied: 'Turno {trick} empatou (Cravou).',
  event_triple_tie: 'Empate nos 3 turnos. A pontuação base da próxima rodada dobrou!',
  event_round_won: 'Fim da rodada. Vencedor: {name} (+{points} pts).',
  event_match_won: 'Grande Vitória! {name} atingiu a meta de {points} pontos!',
  round_num: 'Rodada {num}',
  trick_num: 'Turno {num}/3',
  stakes_current: 'Valendo {stakes} pts',
  stakes_normal: 'Normal (2 pts)',
  stakes_bit_it: 'BIT-IT! (4 pts)',
  stakes_double_bit_it: 'DOUBLE BIT-IT! (8 pts)',
  dealer_badge: 'Distribuidor (Dealer)',

  // Scoreboard
  scoreboard_title: 'Placar (Partida fecha em 16 pontos)',
  binary_bits: 'Gemas de Pontos: [1] [2] [4] [8]',
  pts_counter: '{score} / 16 pts',
  target_goal: 'Partida fecha em 16 pontos',

  // Card Names
  card_ezarion: 'Ezarion (10)',
  card_phantom_general: 'Phantom General (9)',
  card_arrowin: 'Arrowin (8)',
  card_smerlin: 'Smerlin (7)',
  card_kx9: 'KX-9 (6)',
  card_koram: 'Koram (6)',
  card_wizzik: 'Wizzik (5)',
  card_brutus: 'Brutus (4)',
  card_snappy: 'Snappy (3)',
  card_zingo: 'Zingo (2)',
  card_floppy: 'Floppy (1)',
  card_corven: 'Corven (0)',
  card_corven_desc: 'Poder 0. Habilidade: Abate do Ezarion. Derrota o Ezarion (10) e vence a rodada instantaneamente se jogado depois dele!',

  // Rules Dialog
  rules_title: 'Regras Oficiais de Slimelings: Bit-It!',
  rules_tab_basics: 'Visão Geral',
  rules_tab_cards: 'Baralho (30 Cartas)',
  rules_tab_bit_it: 'O Desafio Bit-It!',
  rules_tab_tiebreaks: 'Desempates & Corven',
  rules_deck_overview: 'O baralho possui 30 cartas: 6 Ouros (6 a 10), 20 Comuns (4x 1 a 5) e 4 Corvens (0). Cada jogador recebe 3 cartas por rodada.',
  rules_corven_slay_desc: 'O Corven (0) tem poder zero, mas possui a habilidade suprema Abate do Ezarion: se jogado DEPOIS que o Ezarion (10) já estiver exposto na mesa no mesmo turno, o Corven abate o Ezarion e sua equipe vence a rodada inteira na hora!',
  rules_tiebreak_desc: 'Vencer 2 turnos ganha a rodada. Empates no 2º ou 3º turno dão a vitória a quem venceu o 1º turno ("Fazer a primeira manda no jogo"). Se os 3 turnos empatarem, os pontos da próxima rodada são dobrados.',
  rules_bit_it_ladder: 'Pontuação: Rodada começa valendo 1 se correr / 2 se ganhar. Se alguém pedir Bit-It! e ninguém aceitar, o autor ganha 1 ponto. Se aceitarem, a aposta sobe para 2 se correr / 4 se ganhar. Se alguém pedir Double Bit-It! e o outro correr, o autor ganha 2 pontos; se aceitarem, passa a valer 4 se correr / 8 se ganhar. A partida fecha em 16 pontos.',
  rules_binary_desc: '4 marcadores de [1, 2, 4, 8] gemas somam sua pontuação. A partida fecha em 16 pontos!',
  btn_close: 'Fechar',

  // Emotes & Chat
  emote_hello: 'Olá a todos!',
  emote_good_luck: 'Boa sorte!',
  emote_bit_it: 'BIT-IT! Não tem medo?',
  emote_no_way: 'Não acredito nisso!',
  emote_well_played: 'Muito bem jogado!',
  emote_oops: 'Eita, errei feio!',
  emote_haha: 'Haha, peguei você!',
  emote_nice_try: 'Boa tentativa!',

  // Settings & Status
  sound_on: 'Som: Ligado',
  sound_off: 'Som: Mudo',
  mode_offline: 'Modo Local Offline',
  error_room_not_found: 'Mesa não encontrada. Verifique o código e tente novamente.',
  error_room_full: 'A mesa já está cheia (limite de jogadores atingido).',
  error_invalid_code: 'Código inválido. Digite entre 4 e 12 caracteres alfanuméricos.',
  btn_play_again: 'Jogar Novamente',
  btn_back_to_lobby: 'Voltar ao Lobby',
  status_connected: 'Conectado',
  slime_chat: 'Chat',
  event_player_emote: '{name}: "{emote}"',
  player_opponent: 'Adversário',
  player_champion: 'Campeão',
  card_point: '{val} pt',
  btn_main_menu: 'Menu Principal',
  btn_next_round: 'Próxima Rodada',
  round_end_title: 'Fim da Rodada',
  round_winner_you: 'Você venceu a rodada!',
  round_winner_other: '{name} venceu a rodada!',
  round_tied: 'Rodada empatada!',
  round_points_awarded: '+{points} pontos',
  match_victory: 'Vitória!',
  match_defeat: 'Derrota',
  match_stats_rounds: 'Rodadas jogadas',
  match_stats_final_score: 'Placar final',
};
